import { IApplicationState } from '../../../../../../../types/types';
import { getSignIn } from './getSignIn';

export const getSignInIsShow = (
    state: IApplicationState
): boolean => {
    const isShow = getSignIn(state).isShow;
    return isShow;
}
